export default __webpack_public_path__ + "static/media/profile3.623962b6.jpeg";